import React from "react";
import { range } from "../../utils/array-utils";
import { FormGroup, FormGroupVerticalInput, Label } from "../form";
import Select2 from "../Select2";
import { hasErrorInput, getInputErrorMessage } from "../../utils";
import { allGroupIsEmpty, getSelectedGroupValue } from "../../utils/select-utils";

const SearchGroups = ({
  groupSettings,
  errors,
  inputOptions,
  dataSearch,
  handleSelectChange,
}) => {
  const getOptionsForGroup = (groupNumber, parentGroupId) => {
    const groupKey = `group_${groupNumber}`;
    const groupOptions = inputOptions[groupKey] || [];
    const noneOptions = [{ value: "", label: "[ALL]" }];

    if (allGroupIsEmpty(dataSearch)) {
      const allOptions = groupOptions.map((option) => ({
        value: option.id,
        label: option.name,
      }));
      return noneOptions.concat(uniqueNameGroupOptions(allOptions));
    }

    if (!parentGroupId) {
      if (groupNumber <= firstGroupNumberNonEmpty()) {
        const allOptions = groupOptions.map((option) => ({
          value: option.id,
          label: option.name,
        }));
        return noneOptions.concat(uniqueNameGroupOptions(allOptions));
      }
      return noneOptions;
    } else {
      const hasManyParentGroupId = Array.isArray(parentGroupId);
      let filteredOptions;
      if (hasManyParentGroupId) {
        filteredOptions = groupOptions.filter((option) =>
          parentGroupId.includes(option.parent_group_id)
        );
      } else {
        filteredOptions = groupOptions.filter(
          (option) => option.parent_group_id === parentGroupId
        );
      }
      const formatOptions = filteredOptions.map((option) => ({
        value: option.id,
        label: option.name,
      }));
      return noneOptions.concat(uniqueNameGroupOptions(formatOptions));
    }
  };

  const uniqueNameGroupOptions = (options) => {
    const seenLabels = {};
    return options.reduce((result, { value, label }) => {
      const normalizedLabel = label.toUpperCase();
      if (!seenLabels[normalizedLabel]) {
        seenLabels[normalizedLabel] = value;
        result.push({ value, label });
      } else {
        if (typeof seenLabels[normalizedLabel] === "number") {
          seenLabels[normalizedLabel] = [seenLabels[normalizedLabel], value];
        } else {
          seenLabels[normalizedLabel].push(value);
        }
        result.find(
          (opt) => opt.label.toUpperCase() === normalizedLabel
        ).value = seenLabels[normalizedLabel];
      }
      return result;
    }, []);
  };

  const firstGroupNumberNonEmpty = () => {
    return (
      Object.entries(dataSearch)
        .find(([key, value]) => key.startsWith("group_") && value !== "")?.[0]
        ?.replace("group_", "") || -1
    );
  };
  return (
    <>
      {range(1, 5).map((level) => {
        if (groupSettings[`group_${level}`]?.active) {
          const parentGroupId =
            level > 1 ? dataSearch[`group_${level - 1}`] : null;
          const options = getOptionsForGroup(level, parentGroupId);
          return (
            <FormGroup key={level} direction="horizontal">
              <Label
                text={groupSettings[`group_${level}`]?.name}
                className="lg:min-w-[248px] min-w-[232px]"
              />
              <FormGroupVerticalInput
                error={getInputErrorMessage(errors, `group_${level}`)}
              >
                <Select2
                  options={options}
                  value={getSelectedGroupValue(
                    options,
                    dataSearch[`group_${level}`]
                  )}
                  hasError={hasErrorInput(errors, `group_${level}`)}
                  classNamePrefix="react-select"
                  classSelect="machine-update__form--select"
                  className="xl:w-[280px] w-[260px]"
                  onChange={(option) =>
                    handleSelectChange(`group_${level}`, option.value)
                  }
                  maxLength={30}
                />
              </FormGroupVerticalInput>
            </FormGroup>
          );
        }
        return null;
      })}
    </>
  );
};

export default SearchGroups;
